import React from "react";

const CheckMarkIcon = () => (
  <svg className="checkmark-icon" x="0px" y="0px" viewBox="0 0 21.899 16.706">
    <path
      id="Path_136"
      data-name="Path 136"
      d="M28.468,18.481v0a.932.932,0,0,0-.286-.673h0L14.347,4.387l0,0a.935.935,0,1,0-1.256,1.384L26.213,18.481,21.25,23.444h0a.935.935,0,0,0,1.322,1.322h0l5.61-5.61h0a.932.932,0,0,0,.286-.673Z"
      transform="translate(25.529 -12.262) rotate(90)"
      fill="#39c139"
      stroke="#39c139"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    />
  </svg>
);

export default CheckMarkIcon;
